import React from 'react';
import PropTypes from 'prop-types';
import { StepFlowProvider } from './step-flow-provider-with-context';
import { StepLogger } from './step-logger';

export const WizardStepLogger = ({
  children,
  writeLog,
  shouldPost,
  flow,
  subflow,
  stepToPage,
}) => (
  <StepFlowProvider
    postEventLog={() => writeLog}
    shouldPost={shouldPost}
  >
    {children}
    <StepLogger
      flow={flow}
      subflow={subflow}
      stepToPage={stepToPage}
    />
  </StepFlowProvider>
);

WizardStepLogger.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  writeLog: PropTypes.func.isRequired,
  shouldPost: PropTypes.bool,
  flow: PropTypes.string.isRequired,
  subflow: PropTypes.string.isRequired,
  stepToPage: PropTypes.shape({}).isRequired,
};

WizardStepLogger.defaultProps = {
  shouldPost: true,
};
